import { Authenticationservice } from './../../services/authentication.service';
import { UntypedFormGroup, UntypedFormControl, AbstractControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;
@Component({
  selector: 'app-askforbarcode',
  templateUrl: './askforbarcode.component.html',
  styleUrls: ['./askforbarcode.component.css']
})
export class AskforbarcodeComponent implements OnInit {
  AskBarcode:UntypedFormGroup;
  get form(): { [key: string]: AbstractControl } {
    return this.AskBarcode.controls;
  }
  Searchfmcode:UntypedFormGroup;
  Userinfor:any;
  constructor(private spinner:NgxSpinnerService,private auth: Authenticationservice) {

    let userdata = this.auth.Authention();
    this.Userinfor = userdata;
    console.log(userdata);
    this.Searchfmcode = new UntypedFormGroup({
      fmcode:new UntypedFormControl(''),
    });

    this.AskBarcode = new UntypedFormGroup({
      countcode:new UntypedFormControl('',Validators.required,),
      fmcomment:new UntypedFormControl(''),
      qwant:new UntypedFormControl('0',[Validators.required,]),
    });

   }
 

  ngOnInit(): void {
    setTimeout(() => {
    this.LoadAskedByZone();
    }, 1500);

  }

  // โหลดข้อมูลแปลง
  fmdata:any;
  LoadFarmerData(){
    let data = (this.Searchfmcode.get('fmcode').value).trim();
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[dbQBRD].[dbo].[ck_itid_in_qcard]&w=fmcode='"+data+"'";
    if(data == null || data == ''){}
    else{
      axios.get(url).then(response => {
        this.spinner.show();
      this.fmdata =  response.data.recordset;
      this.spinner.hide();
    })
    .catch(err => {throw(err)});
    }
    
  }

  // ข้อมูลคำขอในโซน 
  askbyzone:any;
  LoadAskedByZone(){
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_request_qcard_w?year_id='6566'&supzone='"+ this.Userinfor.zonedata+"'";
      axios.get(url).then(response => {
        this.spinner.show();
      this.askbyzone =  response.data.recordset;
      this.spinner.hide();
    })
    .catch(err => {throw(err)});


  }
  // เพิ่มข้อมูลขอ Code
  summit = false;
  InsertAskBarcode(){
    this.summit = true;
    
    if (this.AskBarcode.invalid) {
      return;
    }

    let count = this.AskBarcode.get('countcode').value;
    let comment = this.AskBarcode.get('fmcomment').value;
    let qtype = this.AskBarcode.get('qwant').value;
    if(qtype == 0){
      alert('เลือกประเภทคิวก่อนครับ')
      console.log(this.AskBarcode.value);
    }
    else if (count == '') { alert("กรุณาระบุจำนวน");}
    else if (this.onedata == '' ||this.onedata == null) { alert("กรุณาเลือกชาวไร่");}
    else {
      let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/insert_request_qcard?itid='"+this.onedata[0].itid+"'"
      +"&landno='"+this.onedata[0].intlandno+"'"
      +"&qtype=" + qtype
      +"&num_qcard=" + count
      +"&supcode='"+this.Userinfor.supcode+"'"
      +"&supzone='"+this.Userinfor.zonedata+"'"
      +"&comment='"+comment+"'";
      axios.post(url).then(res => {
        if(res.data.rowsAffected[0]==1)
          { alert("บันทึกข้อมูลแล้ว"); 
          this.ChoseModal(); 
          this.AskBarcode.reset();
          this.LoadAskedByZone();
        }
          else { alert("ไม่สำเร็จ");}
        }).catch(err=> {throw(err)})
    }
  }

  // ยกเลิกคำขอ
  CancleAskBarcode(id:any){
    let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/canceled_request_qcard?id="+id;
    if(confirm("ต้องการยกเลิกรายการ ?")==true){
      axios.post(url).then(res => {
        if(res.data.rowsAffected[0]==1)
          { alert("ยกเลิกข้อมูลแล้ว"); 
          this.LoadAskedByZone();
        }
          else { alert("ไม่สำเร็จ");}
        }).catch(err=> {throw(err)})
    } 
    else {
    
    }
  }
  onedata:any;
  Showdata(itid:any){
    $("#AskBarcode").modal('show');
    let data = this.fmdata.filter(el=> el.itid === itid);
    console.log(data);
    this.onedata = data;
  }

  ChoseModal(){
    $("#AskBarcode").modal('hide');
  }

  formatDate(date:any) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear() + 543;

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day, month, year].join('/');
  }
}
